export default __webpack_public_path__ + "static/media/facebook-instant-article.e8c82c8b.jpg";